import { LPSettlementEventTypeEnum } from '@talos/kyoko';
import type { LPSettlementReport } from '../types';

type LPSettlementTradeEvent = Pick<LPSettlementReport, 'EventID' | 'EventType'>;

export function lpSettlementTradeId(event: LPSettlementTradeEvent): string {
  return event.EventType === LPSettlementEventTypeEnum.Trade ? event.EventID : '';
}
